import { Box } from "@mui/material";
import React, { useEffect } from "react";
import {
  useGetEmployeeByRoleQuery,
  useGetRegionLocationByNameQuery,
} from "../../../store/dropdown/dropdownApi";
import DownloadButton from "../../../components/Buttons/DownloadButton";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import { useSelector } from "react-redux";
import { useGetICByLocationQuery } from "../../../store/ic/icApi";
import RegistrationLayout from "../../../components/Layouts/RegistrationLayout";
import { useGetSingleOrgQuery } from "../../../store/org/orgApi";
import { useNavigate } from "react-router-dom";
import RegistrationLogo from "../../../assets/logos/RegistrationLogo.svg";
import PageHeading from "../../../components/General/PageHeading";
import {
  KarnatakaEmailDoc,
  KarnatakaLetterDoc,
} from "../../../components/PDF/Registration";
import { RegistrationCard, RegistrationForm } from "../../../components";
import RegistrationList from "../../../utils/RegistrationList";

const Mode = [
  { id: "ssdfsdf", name: "email" },
  { id: "wrwer", name: "Courier" },
];

const KarnatakaRegistration = () => {
  const navigate = useNavigate();
  const [agree, setAgree] = React.useState(false);
  const [preview, setPreview] = React.useState(false);
  const [locationValue, setLocationValue] = React.useState([]);
  const [complianceDetails, setComplianceDetails] = React.useState([]);
  const [icData, setIcData] = React.useState();
  const [letterMode, setLetterMode] = React.useState("");
  const [locationId, setLocationId] = React.useState("");
  const [representativeName, setRepresentativeName] = React.useState("");
  const [orgData, setOrgData] = React.useState();
  const [pdfPreivewLoader, setPdfPreviewLoader] = React.useState(false);
  // Get Org-ID
  const OrganizationDetails = useSelector((state) => state.auth);
  const { user } = OrganizationDetails;
  const ID = user?.user?.org_id;
  const { data: SingleOrgData } = useGetSingleOrgQuery({ id: ID });

  // Get List of Karanataka's compliance manager
  const { data: KaranatakaComplianceManager } = useGetEmployeeByRoleQuery({
    role: "COMPLIANCE_MANAGER",
    org_id: ID,
  });

  // Get List of Karanataka's Locations
  const { data: KarnatakaLocation } = useGetRegionLocationByNameQuery({
    region: "Karnataka",
    org_id: ID,
  });

  const { data: IcData } = useGetICByLocationQuery({
    location_id: locationId,
  });

  useEffect(() => {
    let temp = [];
    if (KarnatakaLocation?.location) {
      temp = KarnatakaLocation?.location?.map((loc) => {
        return {
          id: loc?.id,
          name: loc?.location_name,
        };
      });
    }
    setComplianceDetails(KaranatakaComplianceManager?.employees);
    setIcData(IcData?.ic?.employees);
    setOrgData({
      name: SingleOrgData?.org?.name,
      address: SingleOrgData?.org?.address_line_1,
    });
    setLocationValue(temp || []);
  }, [
    KaranatakaComplianceManager,
    KarnatakaLocation,
    IcData,
    icData,
    SingleOrgData,
  ]);

  const checkboxHandler = () => {
    setAgree(!agree);
    setPreview(false);
  };

  const onSubmit = (data) => {
    console.log("data", data);
    // if (data.compliance !== "" && data.location !== "" && data.mode !== "0") {
    setLetterMode(data.mode);
    setLocationId(data.location);
    setRepresentativeName(data.compliance);
    setPreview(true);
    setPdfPreviewLoader(true);
    setTimeout(() => {
      setPdfPreviewLoader(false);
    }, 2000);
    // }
  };

  return (
    <RegistrationLayout>
      <PageHeading label="Karnataka Registration" logo={RegistrationLogo} />

      <RegistrationCard
        checkboxHandler={checkboxHandler}
        order={RegistrationList[0].karanataka.order}
        translatedOrder={RegistrationList[0].karanataka.translatedOrder}
        orderUrl={RegistrationList[0].karanataka.orderUrl}
        translatedOrderUrl={RegistrationList[0].karanataka.translatedOrder}
        confirmation={RegistrationList[0].karanataka.confirmation}
      />

      <Box className="tw-px-60">
        <RegistrationForm
          onSubmit={onSubmit}
          complianceDetails={complianceDetails}
          locationValue={locationValue}
          Mode={Mode}
          agree={agree}
          pdfPreivewLoader={pdfPreivewLoader}
        />
        {preview && !pdfPreivewLoader && (
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              marginY: "20px",
            }}
          >
            <PDFViewer
              style={{
                height: "100vh",
                width: "100%",
              }}
              onLoad={() => setPdfPreviewLoader(false)}
            >
              {letterMode === "email" && (
                <KarnatakaEmailDoc
                  ICEmployee={icData}
                  representativeName={representativeName}
                  orgData={orgData}
                />
              )}
              {letterMode === "Courier" && (
                <KarnatakaLetterDoc
                  ICEmployee={icData}
                  representativeName={representativeName}
                  orgData={orgData}
                />
              )}
            </PDFViewer>
          </Box>
        )}

        {preview && !pdfPreivewLoader && (
          <>
            <PDFDownloadLink
              style={{ marginTop: "20px" }}
              document={
                (letterMode === "email" && (
                  <KarnatakaEmailDoc
                    ICEmployee={icData}
                    representativeName={representativeName}
                    orgData={orgData}
                  />
                )) ||
                (letterMode === "Courier" && (
                  <KarnatakaLetterDoc
                    ICEmployee={icData}
                    representativeName={representativeName}
                    orgData={orgData}
                  />
                ))
              }
              fileName="KarnatakaEmailDoc"
            >
              {({ loading }) =>
                loading ? (
                  <DownloadButton
                    loading={loading}
                    styles={{ width: "100%", marginTop: "10rem" }}
                  />
                ) : (
                  <DownloadButton
                    styles={{ width: "100%", marginTop: "10rem" }}
                  />
                )
              }
            </PDFDownloadLink>
            <DownloadButton
              label="Upload Registration"
              styles={{ width: "100%", marginTop: "2rem" }}
              onClick={() => {
                navigate("/home/upload-registration");
              }}
            />
          </>
        )}
      </Box>
    </RegistrationLayout>
  );
};

export default KarnatakaRegistration;
